var _path;
const _excluded = ["title", "titleId"],
  _excluded2 = ["title", "titleId"],
  _excluded3 = ["className", "color", "size", "pointer"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef, memo } from "react";
import { hooks } from '@approvalmax/utils';
const SVG = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M18.403 4.262a.94.94 0 0 1 1.306 1.352l-2.726 2.633L15.63 6.94zm-3.847 2.325L3.926 16.854a1.5 1.5 0 0 0-.441.862l-.248 1.695a1 1 0 0 0 1.308 1.093l1.502-.506a1.5 1.5 0 0 0 .564-.342L20.404 6.333a1.94 1.94 0 1 0-2.696-2.79l-3.138 3.03zm.355 1.048 1.353 1.307-10.348 9.994a.5.5 0 0 1-.188.115l-1.502.505.248-1.695a.5.5 0 0 1 .147-.288z",
    clipRule: "evenodd"
  })));
});
const SvgEdit = (_ref2, ref) => {
  let {
      title,
      titleId
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded2);
  const {
      className = '',
      color,
      size,
      pointer
    } = props,
    restProps = _objectWithoutProperties(props, _excluded3);
  const isClient = hooks.useOnlyClientRendering();
  const colorClassNameMod = color ? 'am-icon_color-' + color : '';
  const sizeClassNameMod = size ? 'am-icon_size-' + size : '';
  const poinerClassNameMod = pointer ? 'am-icon_pointer' : '';
  const classNames = [className, 'am-icon', colorClassNameMod, sizeClassNameMod, poinerClassNameMod].join(' ');
  if (!isClient) return null;
  return /*#__PURE__*/React.createElement(SVG, _extends({
    className: classNames
  }, restProps));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEdit);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xOC40MDMgNC4yNjE5M0MxOC43NjczIDMuOTEwMDkgMTkuMzQ0OCAzLjkxMDA5IDE5LjcwOTEgNC4yNjE5M0MyMC4wOTE3IDQuNjMxNDggMjAuMDkxNyA1LjI0NDYxIDE5LjcwOTEgNS42MTQxNkwxNi45ODMzIDguMjQ2OThMMTUuNjMwMiA2Ljk0MDExTDE4LjQwMyA0LjI2MTkzWk0xNC41NTY0IDYuNTg3MDNMMy45MjY3NSAxNi44NTRDMy42ODgwNiAxNy4wODQ1IDMuNTMyNTYgMTcuMzg3NyAzLjQ4NDYgMTcuNzE2MUwzLjIzNjk5IDE5LjQxMTNDMy4xMjkxOCAyMC4xNDk1IDMuODM4MjkgMjAuNzQxNSA0LjU0NTMxIDIwLjUwMzdMNi4wNDcwOSAxOS45OTg1QzYuMjU4MTcgMTkuOTI3NSA2LjQ1MDc5IDE5LjgxMDQgNi42MTA5NyAxOS42NTU3TDIwLjQwMzggNi4zMzM0M0MyMS4xOTM1IDUuNTcwNzQgMjEuMTkzNSA0LjMwNTM1IDIwLjQwMzggMy41NDI2NkMxOS42NTIgMi44MTY1MSAxOC40NjAxIDIuODE2NTEgMTcuNzA4MyAzLjU0MjY2TDE0LjU3MDQgNi41NzM0OUMxNC41NjU3IDYuNTc3OSAxNC41NjEgNi41ODI0MSAxNC41NTY0IDYuNTg3MDNaTTE0LjkxMDUgNy42MzUyNkwxNi4yNjM2IDguOTQyMTNMNS45MTYyNCAxOC45MzY0QzUuODYyODQgMTguOTg4IDUuNzk4NjQgMTkuMDI3MSA1LjcyODI4IDE5LjA1MDdMNC4yMjY0OSAxOS41NTU5TDQuNDc0MSAxNy44NjA2QzQuNDkwMDkgMTcuNzUxMiA0LjU0MTkyIDE3LjY1MDEgNC42MjE0OCAxNy41NzMzTDE0LjkxMDUgNy42MzUyNloiIGZpbGw9ImN1cnJlbnRDb2xvciIvPgo8L3N2Zz4K";